(() => {
  'use strict';
  const panel = document.querySelector('[data-newsletter]');
  if (panel) {
    const key = 'gainr-newsletter-until';
    const read = () => {
      try { return Number(localStorage.getItem(key)) || 0; }
      catch (_) { try { return Number(sessionStorage.getItem(key)) || 0; } catch (_) { return Infinity; } }
    };
    const remember = days => {
      const until = String(Date.now() + days * 86400000);
      try { localStorage.setItem(key, until); }
      catch (_) { try { sessionStorage.setItem(key, until); } catch (_) {} }
    };
    const close = () => { panel.hidden = true; remember(30); };
    panel.querySelector('[data-newsletter-close]').addEventListener('click', close);
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && !panel.hidden) close();
    });
    document.addEventListener('click', event => {
      if (event.target.closest('[data-cart-open],.purchase-form button')) panel.hidden = true;
    });
    if (panel.querySelector('[data-newsletter-success]')) {
      remember(365); panel.hidden = false;
    } else if (panel.querySelector('[data-newsletter-error]')) {
      panel.hidden = false;
    } else if (read() < Date.now() && !window.Shopify?.designMode) {
      setTimeout(() => {
        if (!document.querySelector('dialog[open]') && !document.activeElement?.matches('input,textarea,select') && read() < Date.now()) panel.hidden = false;
      }, 8000);
    }
  }
  if ('IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => { if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); } });
    }, { threshold: 0.1 });
    document.querySelectorAll('.gainr-brand-page [data-brand-reveal]').forEach(el => { el.classList.add('will-reveal'); observer.observe(el); });
  }
})();

(() => {
  function syncSection(section) {
    const input = section.querySelector('[data-gainr-offer-selector] input:checked');
    if (!input) return;
    section.querySelectorAll('[data-gainr-offer-form]').forEach(panel => { panel.hidden = panel.dataset.gainrOfferForm !== input.value; });
  }
  document.addEventListener('change', event => {
    if (event.target.matches('[data-gainr-offer-selector] input[name="gainr_offer"]')) syncSection(event.target.closest('.gainr-product-page'));
  });
  const syncAll = () => document.querySelectorAll('.gainr-product-page').forEach(syncSection);
  window.addEventListener('pageshow', syncAll);
  document.addEventListener('shopify:section:load', syncAll);
  syncAll();
})();

(() => {const openHelp=()=>{const target=document.getElementById(location.hash.slice(1));if(target?.matches('.gainr-help details')) target.open=true;};addEventListener('hashchange',openHelp);openHelp();})();
